import { render, staticRenderFns } from "./KioskFiles/KioskOrder.html?vue&type=template&id=67121aaa&scoped=true&external"
import script from "./KioskFiles/KioskOrder.js?vue&type=script&lang=js&external"
export * from "./KioskFiles/KioskOrder.js?vue&type=script&lang=js&external"
import style0 from "./KioskFiles/KioskOrder.scss?vue&type=style&index=0&id=67121aaa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67121aaa",
  null
  
)

export default component.exports